<div class="select" [formGroup]="formGroup">
  <select [formControlName]="'year'">
    @for (year of years; track year) {
      <option [value]="year">{{ year }}</option>
    }
  </select>
</div>
